import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getCustomReportHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "customreports", ...action.payload }),
		);
		yield put({
			type: types.GET_CUSTOM_REPORT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CUSTOM_REPORT_ERROR,
			payload,
		});
	}
}

export function* getCustomReportWatcherSaga() {
	yield takeLatest(types.GET_CUSTOM_REPORT_START, getCustomReportHandlerSaga);
}

//create

//delete

function* deleteCustomReportHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("customreports", action.payload),
		);
		yield put({
			type: types.DELETE_CUSTOM_REPORT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CUSTOM_REPORT_ERROR,
			payload,
		});
	}
}

export function* deleteCustomReportWatcherSaga() {
	yield takeLatest(types.DELETE_CUSTOM_REPORT_START, deleteCustomReportHandlerSaga);
}

//update
